export default "__VITE_ASSET__CoAeta$9__"